/**
 * Helpers for when the hub is in an iframe
 */

import { isValidUrl } from './url'

export type iFrameKCConfig = {
  clientId: string
  token: string
  refreshToken: string
}

export type iFrameMessage = {
  origin: string
  data: {
    message: 'token-sent'
    token: string
    refreshToken: string
    clientId: string
  }
}

function isInIframe(): boolean {
  return !!window.top && window.self !== window.top
}

export function shouldGetTokenFromParentWindow(): boolean {
  const searchParams = new URLSearchParams(window.location.search)
  return isInIframe() && searchParams.has('targetOrigin')
}

export async function listenForTokensFromDesmos(): Promise<iFrameKCConfig> {
  if (!shouldGetTokenFromParentWindow()) {
    return Promise.resolve({ token: '', refreshToken: '', clientId: '' })
  }

  let tokenResolve: (val: iFrameKCConfig) => void
  const tokenPromise = new Promise<iFrameKCConfig>((resolve) => {
    tokenResolve = resolve
  })

  const receiveIframeMessage = (event: iFrameMessage) => {
    if (isValidUrl(event.origin)) {
      if (event.data.message === 'token-sent') {
        tokenResolve({
          token: event.data.token,
          refreshToken: event.data.refreshToken,
          clientId: event.data.clientId,
        })
      }
    }
  }

  window.addEventListener('message', receiveIframeMessage)

  const searchParams = new URLSearchParams(window.location.search)
  if (!searchParams.has('targetOrigin')) {
    console.error(
      'iFrame Error: No targetOrigin param provided in the URL. Cannot post to parent window.'
    )
  }

  window.top!.postMessage(
    { message: 'ready-for-token' },
    searchParams.get('targetOrigin')!
  )

  return tokenPromise.then((config) => {
    window.removeEventListener('message', receiveIframeMessage)
    return config
  })
}
